import Image from "next/image";

import cn from "classnames";

import { Text } from "@/components/text/text.component";

import { Chip } from "@/sanity.types";

import { SaleIcon } from "../icons/sale.icon";
import { RichText } from "../richText/richText.component";

export const PackageCard = ({
  title,
  description,
  image,
  imageAlt,
  chips,
  className,
}: PackageCardProps) => {
  const renderChips = () => {
    if (!chips?.length) return null;
    return chips.map((chip) => {
      return (
        <div
          key={chip._key}
          className={cn(
            "flex items-center rounded-full py-1.5 text-sm font-semibold whitespace-nowrap",
            {
              "px-4": !chip.promo,
              "pr-4 pl-1.5": chip.promo,
              border: chip.borderColor,
              "bg-secondary-100 text-white":
                chip.theme === "primary" || chip.theme === "secondary100",
              "bg-secondary text-white": chip.theme === "secondary",
              "bg-greyscale-background text-success": chip.theme === "success",
              "text-success border-success border bg-white":
                chip.theme === "promo",
              "text-greyscale-body bg-white": chip.theme === "white",
              "bg-greyscale-background text-greyscale-body":
                chip.theme === "tertiary",
              "border-primary bg-primary-200 text-secondary border":
                chip.theme === "recommended",
              "bg-primary white": chip.theme === "light",
            },
          )}
          style={{
            backgroundColor: chip?.backgroundColor,
            color: chip?.textColor,
            borderColor: chip?.borderColor,
          }}>
          {chip.promo ? <SaleIcon width={32} /> : null}
          <Text variant="body4">{chip.label}</Text>
        </div>
      );
    });
  };
  return (
    <div
      className={cn(
        "relative flex h-40 w-full flex-col items-center gap-6 rounded-2xl px-8 py-6 text-left text-white transition-transform",
        "from-primary to-secondary-100 bg-radial-[at_50%_50%]",
        className,
      )}>
      <ul className="absolute top-5 left-5 flex flex-wrap gap-2">
        {renderChips()}
      </ul>
      {image && (
        <Image
          width={540}
          height={540}
          src={image}
          alt={imageAlt ?? title}
          className="h-60 w-auto max-w-[70%] shrink-0 object-contain lg:h-auto"
        />
      )}

      <div className="flex flex-1 flex-col items-start gap-6">
        <div className="flex flex-col items-start gap-2">
          <Text variant="h5" className="text-white">
            {title}
          </Text>

          {description && (
            <Text variant="body4" className="min-h-20 text-left text-white">
              {description}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

type PackageCardChip = Chip & { _key?: string };
export type PackageCardProps = {
  title: string;
  price: number;
  description?: string;
  image?: string;
  imageAlt?: string;
  chips?: PackageCardChip[] | null | undefined;
  className?: string;
  href?: string;
};
